import AdaptiveImage from "../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "8a1a50d69aeb02a236f367be5a8cec75.jpg","uri@3x": __webpack_public_path__ + "17bfb408f126aee2dba45fe1fd16c931.jpg",
    width: 960,
    height: 1787
});